<mat-toolbar class="navbar-container">
  <!-- ! Logo -->
  <ddc-logo
    class="daydic-logo"
    routerLinkActive="router-link-active"
    [hasText]="true"
    [routerLink]="'/login'"
    [size]="'medium'"
  ></ddc-logo>
  <!-- Moving text -->
  <div class="marquee-wrapper" *ngIf="_marqueeText">
    <div class="marquee-content">
      <span class="marquee-text">{{ _marqueeText }}</span>
    </div>
  </div>
</mat-toolbar>
